import React, { useRef } from 'react';
import { Ref } from 'semantic-ui-react';

import { StickyContext } from './StickyContext';

export const StickyLayout = ({
  className,
  children,
  name,
}: {
  className?: string;
  children: React.ReactNode;
  name?: string;
}) => {
  const ref = useRef<HTMLElement | null>(null);

  return (
    <div data-test={name} className={className}>
      <Ref innerRef={ref}>
        <StickyContext.Provider value={ref}>{children}</StickyContext.Provider>
      </Ref>
    </div>
  );
};
